<template lang="html">
  <div class="centerx">
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer ce contact ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="acceptDelete()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="declineDelete()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup title="" :active.sync="isPopupActive" class="mw-1/2">
      <div class="container" style="min-width: 800px; max-width: 1200px;">
        <div class="vx-col mb-base w-full">
          <div class="vx-row w-full ml-2">
            <div class="vx-col left-elem">
            <vs-button @click="modifyProvider(provider.id)">
              Modifier Prestataire
            </vs-button>
            </div>
          </div>
          <div class="vx-row w-full center ml-1">
            <span>
              <vs-icon icon="business" size="75px" color="black"></vs-icon>
            </span>
          </div>
          <div class="vx-row center ml-1">
            <div class="vx-col title f-color">
              {{ provider.society }}
            </div>
          </div>
          <div class="vx-row w-full ml-1 t-border">
            <div class="vx-col w-1/8 mt-2">
              Note :
            </div>
            <div class="vx-col w-1/8 mt-2">
            <span><star-rating
            :show-rating=false
            :star-size="20"
            :read-only="true"
            :rtl="$vs.rtl"
            :rating="provider.rate"
            active-color="#35e9fd"
            ></star-rating></span>
            </div>
            <div class="vx-col w-1/8 mt-2" v-if="provider.website">
              Site web :
            </div>
            <div class="vx-col w-1/8 mt-2" v-if="provider.website">
              <vx-tooltip
                :text="provider.website"
                position="top"
                class="flex center"
                >
                <vs-button
                    color="primary"
                    size="large"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-link-2"
                    :href="provider.website"
                    target="_blank"
                ></vs-button>
              </vx-tooltip>
            </div>
          </div>
          <div class="vx-row w-full ml-1 mt-2">
            <div class="vx-row w-full ml-1 mt-2">
            <div class="vx-col w-1/8 mt-2">
              Statut :
            </div>
            <div class="vx-col w-1/2 mt-2">
              <vs-chip
						style="width: 80px; margin-left: 10px; border-radius: 6px; padding-top: 2px;"
						:color="getProviderStatusColor(provider.status)">{{
						getStatusName(provider)
					}}</vs-chip>
            </div>
          </div>
            <div class="vx-col w-1/8 mt-2">
              Expertise :
            </div>
            <div class="vx-col w-1/2 mt-2">
              <vs-chip v-for="service_name in provider.service_name_list" :key="service_name">{{service_name}}</vs-chip>
            </div>
          </div>
          <div class="vx-row w-full ml-1 mt-2">
            <div class="vx-col w-1/8 mt-2">
              Tags :
            </div>
            <div class="vx-col w-1/2 mt-2">
              <vs-chip v-for="tag in listDomaine">{{tag.name}}</vs-chip>
            </div>
          </div>
          <div class="vx-row w-full ml-1 mt-2">
            <div class="vx-col w-1/8 mt-2">
              Commentaire :
              </div>
            <div class="vx-col w-7/8 mt-2">
              {{ provider.commentary }}
            </div>
          </div>
          <div class="vx-row center_div t-border">
            <vs-table :data="relatedUser" v-if="relatedUser">
              <template slot="thead">
                <vs-th>Civilité</vs-th> <!-- Madame ou Monsieur -->
                <vs-th>Prénom</vs-th> <!-- Prénom -->
                <vs-th>Nom</vs-th> <!-- Nom -->
                <vs-th>Type de contact</vs-th> <!-- Commercial ou Facturation -->
                <vs-th>Email</vs-th> <!-- Email -->
                <vs-th>Téléphone</vs-th> <!-- Téléphone -->
                <vs-th>Accès Dashboard</vs-th>
                <vs-th></vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope={data}>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ getUserCivility(data[indextr].civility) }}</vs-td> <!-- Madame ou Monsieur -->
                  <vs-td>{{ data[indextr].firstname }}</vs-td> <!-- Prénom -->
                  <vs-td>{{ data[indextr].lastname }}</vs-td> <!-- Nom -->
                  <vs-td>{{ getUserTitle(data[indextr].user_type) }}</vs-td> <!-- Commercial ou Facturation -->
                  <vs-td>{{ data[indextr].email }}</vs-td> <!-- Email -->
                  <vs-td>{{ data[indextr].phone }}</vs-td> <!-- Téléphone -->
                  <vs-td>{{ getUserDashboardAccess(data[indextr].hasAccess) }}</vs-td> <!-- hasAccess to Dashboard -->
                  <vs-td><vs-button @click="modifyContact(data[indextr].id)">Modifier</vs-button></vs-td>
                  <vs-td><vs-button @click="displayValidationPopup(data[indextr].id)">Désassocier</vs-button></vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-row center_div t-border">
            <vs-button class="mt-2" @click="newContact(provider.id)">Nouveau contact</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import StarRating from "vue-star-rating";

export default {
	name: "ProviderInfoPopup",
	props: {
		provider: Object,
		popupActive: Boolean,
		router: Object,
		apiUrl: String,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		StarRating
	},
	created(){
		this.refreshContact();
    this.getActivityDomain();
	},
	watch: {
		provider: function(){
			this.getAllRelatedUser();
		},
		popupActive: function(){
			this.isPopupActive = this.popupActive;
		},
		isPopupActive: function(){
			this.$emit("update:popupActive", this.isPopupActive);
		}
	},

	data() {
		return {
			relatedUser: null,
			commercialSociety: null,
			commercialContact: null,
			billingContact: null,
			isPopupActive: this.popupActive,
			showValidationPopup: false,
			selectedContact: null,
      listDomaine: []
		};
	},

	methods: {
    getStatusName(row){
			return this.getProvidersStatus().find((ele) => ele.id == row.status)["name"];
		},
    getActivityDomain(){
			this.$http.get(this.apiUrl + "tags/provider/" + this.$props.provider.id).then(res => {
				let tmp = res.data;
				for(let tag of tmp){
					tag['name'] = tag.tag_name;
					delete tag.tag_name;
				}
				this.listDomaine = tmp;
			})
			.catch(err => console.log(err));
		},

		getAllRelatedUser(providerId) {
			this.$http
				.get("usersProviders/getup/" + providerId)
				.then(res => {
					this.relatedUser = res.data;
				})
				.catch(err => console.error(err));
		},

		/**
		 * Open form to modify the provider passed in argument
		 * @param {Number} providerId - Contact ID to modify
		 */
		modifyProvider(providerId){
			sessionStorage.setItem("popupOrigin", providerId);
			this.router.push({name: "update_entity", params: {providerId: providerId, updateEntityForm: "providers"}});
			this.isPopupActive = false;
			//console.log("modifyProvider");
		},

		/**
		 * Open form to modify the contact passed in argument
		 * @param {Number} contactId - Contact ID to modify
		 */
		modifyContact(contactId){
			//console.log(contactId);
			let updateEntityForm = "contact";
			let providerId = this.$props.provider.id;
			sessionStorage.setItem("popupOrigin", providerId);
			this.router.push({name: "update_entity", params: {contactId, providerId, updateEntityForm}});
			this.isPopupActive = false;
			//console.log("modifyContact");
		},

		/**
		 * Open form to create new contact for the society passed in argument
		 * @param {Number} societyId - Society ID to add contact to
		 */
		newContact(providerId){
			let newEntityForm = "contact";
			sessionStorage.setItem("popupOrigin", providerId);
			this.router.push({name: "new_entity", params: {providerId, newEntityForm}});
			this.isPopupActive = false;
		},

		/**
		 * Delete the contact passed in argument
		 * @param {Number} contactId - Contact ID to delete
		 */
		deleteContact(contactId){
			//console.log(this.$props.apiUrl);
			this.$http.delete(this.$props.apiUrl + "usersProviders/delete/"+ this.$props.provider.id + "/" + contactId)
				.then(() => {
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Contact effacé avec succès."
					});
					// Refresh List
					this.refreshContact();
				})
				.catch(err => {
					//console.log(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Le contact n'a pas été effacé."
					});
				});
		},

		displayValidationPopup(contactId){
			this.selectedContact = contactId;
			this.showValidationPopup = true;
		},

		acceptDelete(){
			this.deleteContact(this.selectedContact);
			this.showValidationPopup = false;
		},

		declineDelete(){
			this.selectedContact = null;
			this.showValidationPopup = false;
		},

		refreshContact(){
			//console.log("Refreshing Contacts");
			this.getAllRelatedUser(this.$props.provider.id);
		},
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.right-elem {
  justify-content: flex-end;
}

.bg-color {
  background: #35e9fd !important;
}

.t-border {
  border-top: 1px solid grey;
}

.l-border {
  border-left: 1px solid grey;
}

.title {
  font-weight: 600;
  font-size: 2em;
}

.f-color {
  color: black;
}

.center-align {
  display: flex;
  align-items: center;
}

.no-width-limit{
  width: unset;
}
</style>
